export const iconFontAwesomeTransportationBabyCarriage = (
	<i className="fa-solid fa-baby-carriage"></i>
);
